import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFuelCardQuickInfo extends Layout {
    panelFuelCard: Panel;
    sourceFuelCardLookup: DataSource;
    textboxAccountId: Textbox;
    textboxCardStatus: Textbox;
    textboxFuelInterfaceId: Textbox;
    textboxId: Textbox;
    textboxSubAccount: Textbox;
}
